/**
*
* LoadPlanErrorDialog
*
*/

import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import homePageMessages from 'pages/HomePage/messages';
import messages from './messages';

import { KompisPrompt, KompisText } from '@inter-ikea-kompis/react-components';
import { PromptButtonTypeEnum } from '@inter-ikea-kompis/component-prompt';
import { SkapaTheme } from '@inter-ikea-kompis/themes';


function LoadPlanErrorDialog({ show, onDismiss, cwcalcReachedFromIpexGallery }) {
  
  const { formatMessage } = useIntl();
  return (
    <KompisPrompt
      heading={formatMessage({
        id: messages.codeNotFound.id, defaultMessage: messages.codeNotFound.defaultMessage
      })}
      primaryButtonLabel={formatMessage({
        id: messages.dismiss.id, defaultMessage: messages.dismiss.defaultMessage
      })}
      onButtonClick={event => {
        onDismiss();
        if (event.detail.type === PromptButtonTypeEnum.primaryButton) {
          // onContinueClick();
        } else {
          // onBackClick();
        }
      }}
      visible={show}
      theme={SkapaTheme}
      disableIframeSticky={cwcalcReachedFromIpexGallery}
    >
      <KompisText theme={SkapaTheme}>
        {formatMessage({
          id: homePageMessages.loadFailed.id, defaultMessage: homePageMessages.loadFailed.defaultMessage
        })}
      </KompisText>
    </KompisPrompt>)
}

LoadPlanErrorDialog.propTypes = {
  show: PropTypes.bool.isRequired,
  onDismiss: PropTypes.func.isRequired,
};

export default LoadPlanErrorDialog;
